import { IRequest } from '@r1-frontend/shared/types/IRequest';

import { TAdvertising, TContentBlock, TResponseDto } from './dto/ResponseDto';
/*
* Данные страницы
* https://master.api-content.sandbox.d2c.r-one.io/docs/v1#/%D0%A1%D1%82%D1%80%D0%B0%D0%BD%D0%B8%D1%86%D1%8B/get_v1_page_view
*/
const pageView = (providerId: number, id: string): IRequest => ({
    uri: 'v1/page/view',
    method: 'GET',
    queryParams: { providerId, id },
});

export default pageView;

export type {
    TAdvertising,
    TContentBlock,
    TResponseDto,
};
